const getScoresData = (linescore = {}, teams) => {
    let homeScore = 0;
    let awayScore = 0;
    let totalsData = {};
    if (linescore.teams && linescore.teams.home && linescore.teams.home.hasOwnProperty('runs')) {
        homeScore = linescore.teams.home.runs;
        awayScore = linescore.teams.away && linescore.teams.away.runs;
        totalsData = linescore.teams;
    } else if (teams) {
        homeScore = teams.home && teams.home.score;
        awayScore = teams.away && teams.away.score;
        totalsData = {
            home: {
                runs: homeScore
            },
            away: {
                runs: awayScore
            }
        };
    }
    return {
        homeScore,
        awayScore,
        totalsData
    };
};

export default getScoresData;
